// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"853f6d1e","513":"15775e42","703":"a1512a7e","787":"feed191a"}[chunkId] + ".chunk.js";
};